import { GAME_NAME } from 'commons/superApp/models/games';

export const DESCRIPTIONS = {
	ONE_OUT_OF_TWO_WIN: '1 out of 2 win',
	ONE_OUT_OF_FOUR_WIN: '1 out of 4 win',
	TWO_OUT_OF_FOUR_WIN: '2 out of 4 win',
	THREE_OUT_OF_FOUR_WIN: '3 out of 4 win'
};

export const DESCRIPTION_PLAYERS_PER_TABLE_MAP = {
	[DESCRIPTIONS.ONE_OUT_OF_TWO_WIN]: 2,
	[DESCRIPTIONS.ONE_OUT_OF_FOUR_WIN]: 4,
	[DESCRIPTIONS.TWO_OUT_OF_FOUR_WIN]: 4,
	[DESCRIPTIONS.THREE_OUT_OF_FOUR_WIN]: 4
};

export const DESCRIPTION_WINNER_TYPE_MAP = {
	[DESCRIPTIONS.ONE_OUT_OF_TWO_WIN]: 'ONE_VS_ONE_BATTLE',
	[DESCRIPTIONS.ONE_OUT_OF_FOUR_WIN]: 'ONE_WINNER',
	[DESCRIPTIONS.TWO_OUT_OF_FOUR_WIN]: 'TWO_WINNERS',
	[DESCRIPTIONS.THREE_OUT_OF_FOUR_WIN]: 'THREE_WINNERS'
};

export const WINNER_TYPE_NUMBER_OF_WINNERS_MAP = {
	ONE_VS_ONE_BATTLE: 1,
	THREE_WINNERS: 3,
	TWO_WINNERS: 2,
	ONE_WINNER: 1
};

export const BOOLEAN_OPTIONS = [
	{ id: true, label: 'TRUE' },
	{ id: false, label: 'FALSE' }
];

export const DESCRIPTION_OPTIONS = [
	{ id: DESCRIPTIONS.ONE_OUT_OF_TWO_WIN, label: DESCRIPTIONS.ONE_OUT_OF_TWO_WIN },
	{ id: DESCRIPTIONS.ONE_OUT_OF_FOUR_WIN, label: DESCRIPTIONS.ONE_OUT_OF_FOUR_WIN },
	{ id: DESCRIPTIONS.TWO_OUT_OF_FOUR_WIN, label: DESCRIPTIONS.TWO_OUT_OF_FOUR_WIN },
	{ id: DESCRIPTIONS.THREE_OUT_OF_FOUR_WIN, label: DESCRIPTIONS.THREE_OUT_OF_FOUR_WIN }
];

export const TOURNAMENT_TYPE_OPTIONS = [
	{ id: 'MEGA_TOURNAMENT', label: 'MEGA_TOURNAMENT' },
	{ id: 'PLAY_WITH_MONEY', label: 'PLAY_WITH_MONEY' },
	{ id: 'PLAY_FOR_FREE', label: 'PLAY_FOR_FREE' }
];

export const QUESTION_BANK_GAMES = [{ id: 'zcm', label: 'ZCM' }];

export const ENVIRONMENT = [
	{ id: 'staging', label: 'DEV' },
	{ id: 'prod', label: 'PROD' }
];

export const ZUPEE_GAME_TYPE_OPTIONS = [
	{ id: 'TIME_LIMIT_5', label: 'TIME_LIMIT_5' },
	{ id: 'N-1_WIN_EQUAL', label: 'N-1_WIN_EQUAL' },
	{ id: 'N-1_WIN_DIFFERENT', label: 'N-1_WIN_DIFFERENT' }
];

export const USER_LEVELS_SUPPORTED_OPTIONS = [
	{ id: 1, label: '1' },
	{ id: 2, label: '2' }
];

export const STT_OPTIONS = [{ id: 15, label: '15' }];

export const WINNER_TYPE_NAME_MAP: { [key: string]: string } = {
	ONE_VS_ONE_BATTLE: '1v1 Battle',
	THREE_WINNERS: '3 Winners',
	TWO_WINNERS: '2 Winners',
	ONE_WINNER: '1 Winner'
};

export const QUESTION_BANK_ENVIRONMENT: { [key: string]: string } = {
	STAGING: 'staging',
	PROD: 'prod'
};

export interface IAppRequestPayload {
	displayName?: string;
	appName: string;
	isGold: boolean;
}

export interface IQuestionBankApprovalQuestionBankData {
	gameName: GAME_NAME;
	docId: string;
}

export const CQuestionBankDiffModelStyle = {
	minHeight: '400px',
	overflow: 'auto'
};
